import type { Preference } from '../../types';

/**
 * Preferences: Ranked institutional preferences for timetable optimization
 * These represent school-wide priorities that guide the generation algorithm
 */
export const mockPreferences: Preference[] = [
  {
    id: 'pref-1',
    name: 'Minimize Teacher Commute Time',
    description: 'Reduce unnecessary movement between buildings for teachers',
    category: 'teacher',
    rank: 1,
    isActive: true,
    impact: 'high',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-2',
    name: 'Student Wellbeing',
    description: 'Prioritize balanced daily schedules that support student concentration',
    category: 'student',
    rank: 2,
    isActive: true,
    impact: 'high',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-3',
    name: 'Maximize Room Efficiency',
    description: 'Use specialist rooms effectively and minimize empty periods',
    category: 'room',
    rank: 3,
    isActive: true,
    impact: 'medium',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-4',
    name: 'Department Collaboration Time',
    description: 'Enable common planning time for subject departments',
    category: 'collaboration',
    rank: 4,
    isActive: true,
    impact: 'medium',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-5',
    name: 'Curriculum Balance',
    description: 'Spread core subjects evenly across the week',
    category: 'curriculum',
    rank: 5,
    isActive: true,
    impact: 'medium',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-6',
    name: 'Minimize Split Days',
    description: 'Reduce gaps in teacher and student schedules',
    category: 'scheduling',
    rank: 6,
    isActive: true,
    impact: 'medium',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-7',
    name: 'Part-Time Staff Efficiency',
    description: 'Consolidate part-time teacher schedules into fewer days',
    category: 'teacher',
    rank: 7,
    isActive: true,
    impact: 'low',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-8',
    name: 'Exam Class Priority',
    description: 'Give Years 11 and 13 optimal timings for core exam subjects',
    category: 'curriculum',
    rank: 8,
    isActive: true,
    impact: 'medium',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-9',
    name: 'Cross-Curricular Opportunities',
    description: 'Enable parallel subject delivery for integrated learning',
    category: 'curriculum',
    rank: 9,
    isActive: true,
    impact: 'low',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
  {
    id: 'pref-10',
    name: 'Cover Arrangement Flexibility',
    description: 'Schedule parallel year group lessons to simplify absence coverage',
    category: 'scheduling',
    rank: 10,
    isActive: true,
    impact: 'low',
    createdAt: new Date('2025-01-10'),
    updatedAt: new Date('2025-01-10'),
  },
];

export const getPreferencesByCategory = (category: Preference['category']): Preference[] => {
  return mockPreferences.filter((pref) => pref.category === category);
};

export const getActivePreferences = (): Preference[] => {
  return mockPreferences.filter((pref) => pref.isActive);
};

export const getPreferencesByRank = (): Preference[] => {
  return [...mockPreferences].sort((a, b) => a.rank - b.rank);
};

export const getHighImpactPreferences = (): Preference[] => {
  return mockPreferences.filter((pref) => pref.impact === 'high');
};
